import React, {useEffect} from 'react'
import {Row, Col, Container } from 'react-bootstrap';
import "../../componants/PrivacyPolicy/PrivacyPolicy.scss";

export const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, [])

    return (   
    <>
    <Container>
    <div className="privacy-policy-hero inner-hero-phone">
        <h1 className="vertical-center">Privacy Policy</h1>
        
    </div>
        <Row className="padding-y-40 align-items-center paragraph-wrpr-row side-pattern">
        <Col md={12} className="top-space">
            <div className="li-wrapper">
            <p>Your privacy is important to us. To better protect your privacy we provide this notice explaining our online information practices and the choices you can make about the way your information is collected and used. To make this notice easy to find, we make it available on our homepage and at every point where personally identifiable information may be requested.</p>
            <h2 className='privacy-subtitle margin-30'>The Information We Collect</h2>
            <p>This notice applies to all information collected or submitted on any of the Ticketingsoftwares websites. On some pages, you can order products, make requests, and register to receive materials. The types of personal information collected at these pages are:</p>
            <div className='bulletlisting'>
            <ul>
                <li>Name</li>
                <li>Address</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>ID PROOF</li>
            </ul>
            </div>

            <h2 className='privacy-subtitle'>The Way We Use Information</h2>
            <div className='bulletlisting'>
            <ul>
                <li>We use the information you provide about yourself when placing an order only to complete that order. We do not share this information with outside parties except to the extent necessary to complete that order.</li>
                <li>We use return email addresses to answer the email we receive. Such addresses are not used for any other purpose and are not shared with outside parties.</li>
                <li>You can register with our website if you would like to receive user our services as well as updates on our new products and services. Information you submit on our website will not be used for this purpose unless you fill out the registration form.</li>
                <li>We never use or share the personally identifiable information provided to us online in ways unrelated to the ones described above without also providing you an opportunity to opt-out or otherwise prohibit such unrelated uses.</li>
            </ul>
            </div>

            <h2 className='privacy-subtitle'>Our Commitment to Data Security</h2>
            <div className='bulletlisting'>
            <ul>
                <li>To prevent unauthorized access, maintain data accuracy, and ensure the correct use of information, we have put in place appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect online.</li>
            </ul>
            </div>

            <h2 className='privacy-subtitle'>Our Commitment to Children's Privacy</h2>
            <div className='bulletlisting'>
            <ul>
                <li>Protecting the privacy of the very young is especially important. For that reason, we never collect or maintain information at our website from those we actually know are under 13, and no part of our website is structured to attract anyone under 13.</li>
            </ul>
            </div>

            <h2 className='privacy-subtitle'>How You Can Access Or Correct Your Information</h2>
            <div className='bulletlisting'>
            <ul>
                <li>You can access all your personally identifiable information that we collect online and maintain by a secure login into the clients area.</li>
                <li>If for some reason you cannot login or have lost your password you can use the "lost password" tool.</li>
                <li>If that process has failed you may then contact us and to protect your privacy and security, we will also take reasonable steps to verify your identity before granting access or making corrections.</li>
            </ul>
            </div>

            <h2 className='privacy-subtitle'>Site Usage Information</h2>
            <div className='bulletlisting'>
            <ul>
                <li>Similar to other commercial web sites, our web site utilizes a standard technology called "cookies" and web server logs to collect information about how our web site is used. Information gathered through cookies and web server logs may include the date and time of visits, the pages viewed and time spent at our web site.</li>
            </ul>
            </div>

            <h2 className='privacy-subtitle'>How To Contact Us</h2>
            <div className='bulletlisting'>
            <ul>
                <li>Should you have other questions or concerns about these privacy policies, please send us an email.</li>
            </ul>
            </div>

            </div>
        </Col>
        </Row>
     </Container>
    </>
     )
}